<template>
  <div class="container">
    <div class="spaced-row">
      <h3>Users</h3>
      <div class="grow"></div>
      <mad-button color="brown" @click.prevent="goToCreate">
        <mad-icon mdi="plus" />Create user
      </mad-button>
    </div>

    <br>

    <mad-datatable :rows="rows" :columns="columns" :per-page="10">
      <template slot="user" slot-scope="{row}">
        {{ row.first_name }} {{ row.last_name }}
      </template>
      <template slot="user locations" slot-scope="{row}">
        <template v-for="location in row.locations_list">
          <mad-button
            :key="location.id"
            :title="location.name"
            color="brown"
            class="_table-button"
            @click.stop="$router.push(`/locations/${location.id}`)"
          >
            <div class="_trunc-text">{{ location.name }}</div>
          </mad-button>
        </template>
      </template>
    </mad-datatable>
  </div>
</template>

<script>
export default {
  data: () => ({
    users: [],
    columns: [
      { key: 'user', sort: 'name' },
      { key: 'user locations', sort: row => row.locations_list.length },
    ],
  }),

  computed: {
    rows() {
      return this.users.map(user => ({
        ...user,
        locations_list: this.getUserLocations(user),
        click: e => this.goToUser(user),
      }))
    },
  },

  watch: {
    data: {
      handler() {
        this.fetchData()
      },
    },
  },

  created() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      if (!this.users) return

      const users = await this.$store.dispatch('getUsers', {})

      this.users = users
    },
    goToUser(user) {
      this.$router.push(`/users/${user.id}`)
    },
    getUserLocations(user) {
      return user.locations.map(location => location)
    },
    goToCreate() {
      this.$router.push('/users/new-user')
    },
  },
}
</script>

<style>
._table-button {
  margin: 2px;
}

._trunc-text {
  width: 75px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
